import React from 'react';
import PropTypes from 'prop-types';
import { hasPrivilege } from '../../../hocs/withPrivileges';
import useAuthentication from '../../../hooks/useAuthentication';
import ReadonlyField from '../ReadonlyField';
import FlagIconField from '../FlagIconField';
import FlagIcon from '../../FlagIcon';
import { resolveValue } from '../../../utils/fields';
import { NO_STATE } from '../../../hooks/useExtendedState';
import { extendedStateType } from '../../../types';

PrivilegedFlagIconField.propTypes = {
    sufficientPrivileges: PropTypes.arrayOf(PropTypes.string).isRequired,
    sufficientReadPrivileges: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.string,
    state: extendedStateType,
};

PrivilegedFlagIconField.defaultProps = {
    value: undefined,
    sufficientReadPrivileges: null,
    state: NO_STATE,
};

function PrivilegedFlagIconField(props) {
    const {
        sufficientPrivileges,
        sufficientReadPrivileges,
        value,
        state,
        ...rest
    } = props;
    const { userPrivileges } = useAuthentication();
    const resolvedValue = resolveValue(value, state);
    const canWrite = hasPrivilege(userPrivileges, sufficientPrivileges);
    const canRead = !canWrite && (sufficientReadPrivileges === null || hasPrivilege(userPrivileges, sufficientReadPrivileges));
    return (
        canWrite
            ? (
                <FlagIconField
                    value={value}
                    state={state}
                    {...rest}
                />
            )
            : (
                canRead && (
                    <ReadonlyField
                        value={
                            resolvedValue && <FlagIcon code={resolvedValue} squared />
                        }
                        state={state}
                        {...rest}
                    />
                )
            )
    );
}

export default PrivilegedFlagIconField;
